"use client";

import React from "react";
export default function RefundPolicyText() {
  return <section data-section-id="254703" id="refund-policy-text" className="bg-black text-white min-h-screen py-24 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto border border-primary rounded-lg p-8 md:p-12 bg-card/50 backdrop-blur-sm">
        <div className="mb-12 text-center">
          <h1 className="text-5xl font-default font-bold mb-4 tracking-tight">Refund Policy</h1>
          <p className="text-muted-foreground font-sans">Effective Date: June 2026</p>
        </div>

        <div className="space-y-8">
          <p className="text-lg leading-relaxed font-sans text-muted-foreground text-center max-w-2xl mx-auto">All RecoupTime AI Assessment payments are non-refundable upon delivery of the final assessment report. If you have submitted payment and wish to cancel before your report is built, please email us within 24 hours of payment and we will issue a full refund. Once your report has been developed the assessment fee is considered earned and non-refundable.</p>
        </div>
      </div>
    </section>;
}